import { html, nothing } from 'lit';
import { ref } from 'lit/directives/ref.js';
import SotbitInput from '../index.js';
import { DEFAULT_INPUT_PROPERTIES } from '@/components/input/constants.js';
import { EVENT_MASK_ACCEPT, EVENT_MASK_COMPLETE } from '@/components/input/masked/constants.js';
import { createInputMask } from '@/directives/InputMaskDirective.js';
import { getMessage } from '@/localization.js';
import messages from './localization.json';

export default class SotbitInputMasked extends SotbitInput {
    static properties = {
        ...DEFAULT_INPUT_PROPERTIES,
        clearable: { type: Boolean },
        mask: { type: String },
        size: { type: String },
    };

    get value() {
        let value = '';

        if (this._mask?.value) {
            value = this._mask.value;
        } else {
            value = this.inputRef.value?.value || '';
        }

        return value;
    }

    set value(value) {
        if (!(this.inputRef.value instanceof HTMLInputElement)) {
            return;
        }

        value = value.trim().replace(/[^0-9+]/g, '');

        if (this._mask) {
            this._mask.unmaskedValue = value;
        } else {
            this.inputRef.value.value = value;
        }

        this._internals?.setFormValue(this.value);

        if (this.error) {
            this.checkValidity(false);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();

        queueMicrotask(() => {
            if (!this.isConnected) {
                this._mask?.destroy();
            }
        });
    }

    firstUpdated() {
        super.firstUpdated();

        if (!this.inputRef.value || !this.mask) {
            return;
        }

        this.inputRef.value.setCustomValidity(getMessage(messages, 'patternMismatchErrorMessage'));

        this._mask = createInputMask(this.inputRef.value, {
            mask: this.mask,
            lazy: false,
        });

        this._mask.on('accept', () => {
            this._internals?.setFormValue(this.value);

            this.inputRef.value?.setCustomValidity(
                this._mask?.masked.isComplete ? '' : getMessage(messages, 'patternMismatchErrorMessage')
            );

            this.dispatchEvent(
                new Event(EVENT_MASK_ACCEPT, {
                    bubbles: true,
                    composed: true,
                })
            );
        });

        this._mask.on('complete', () => {
            this.dispatchEvent(
                new Event(EVENT_MASK_COMPLETE, {
                    bubbles: true,
                    composed: true,
                })
            );
        });
    }
    render() {
        return html`
            <sotbit-input-style
                size="${this.size || nothing}"
                error-text="${this.errorText || nothing}"
                helper-text="${this.helperText || nothing}"
                label="${this.label || nothing}"
                part="input-style"
                ?error="${this.error}"
                ${ref(this.styleRef)}
                @change="${this._handleChange}"
                @keydown="${this._handleKeydown}"
            >
                <input
                    type="text"
                    name="${this.name || nothing}"
                    slot="input"
                    part="input"
                    placeholder="${this.placeholder}"
                    ?disabled="${this.disabled}"
                    ?readonly="${this.readonly}"
                    ?required="${this.required}"
                    ${ref(this.inputRef)}
                />
            </sotbit-input-style>
        `;
    }
}
